import type { ReactNode } from 'react';

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  icon?: string;
  action?: ReactNode;
}

export default function SectionHeading({ title, subtitle, icon, action }: SectionHeadingProps) {
  return (
    <div className="mb-5 flex items-end justify-between gap-4">
      <div>
        <h2 className="flex items-center gap-2 text-lg font-bold text-foreground-950 md:text-xl">
          {icon && <i className={`${icon} text-accent-500`}></i>}
          <span className="relative">
            {title}
            <span className="absolute -bottom-1 left-0 h-0.5 w-8 rounded-full bg-accent-500"></span>
          </span>
        </h2>
        {subtitle && <p className="mt-2 text-sm text-foreground-500">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}